module.exports = __webpack_public_path__ + "media/images/plans/photo/about-df963292838556091d4f90ed055c9f49.jpg";